(function (ssm, window) {

    function StateManager() {
        this.callbacks = {
            'sm': {
                'enter': [],
                'leave': [],
                'resize': [],
                'firstRun': []
            },

            'md': {
                'enter': [],
                'leave': [],
                'resize': [],
                'firstRun': []
            },

            'lg': {
                'enter': [],
                'leave': [],
                'resize': [],
                'firstRun': []
            },

            'xl': {
                'enter': [],
                'leave': [],
                'resize': [],
                'firstRun': []
            },

            'mobile': {
                'enter': [],
                'leave': [],
                'resize': [],
                'firstRun': []
            },

            'desktop': {
                'enter': [],
                'leave': [],
                'resize': [],
                'firstRun': []
            }
        };
    }

    StateManager.prototype.run = function() {
        this.ssm = ssm;
        this.ssm.addState({
            id: 'sm',
            query: '(min-width: 576px) and (max-width: 767px)',
            onEnter: this.onEnter('sm'),
            onLeave: this.onLeave('sm'),
            onResize: this.onResize('sm'),
            onFirstRun: this.onFirstRun('sm')
        });

        this.ssm.addState({
            id: 'md',
            query: '(min-width: 768px) and (max-width: 991px)',
            onEnter: this.onEnter('md'),
            onLeave: this.onLeave('md'),
            onResize: this.onResize('md'),
            onFirstRun: this.onFirstRun('md')
        });

        this.ssm.addState({
            id: 'lg',
            query: '(min-width: 992px) and (max-width: 1199px)',
            onEnter: this.onEnter('lg'),
            onLeave: this.onLeave('lg'),
            onResize: this.onResize('lg'),
            onFirstRun: this.onFirstRun('lg')
        });

        this.ssm.addState({
            id: 'xl',
            query: '(min-width: 1200px)',
            onEnter: this.onEnter('xl'),
            onLeave: this.onLeave('xl'),
            onResize: this.onResize('xl'),
            onFirstRun: this.onFirstRun('xl')
        });

        this.ssm.addState({
            id: 'mobile',
            query: '(max-width: 991px)',
            onEnter: this.onEnter('mobile'),
            onLeave: this.onLeave('mobile'),
            onResize: this.onResize('mobile'),
            onFirstRun: this.onFirstRun('mobile')
        });

        this.ssm.addState({
            id: 'desktop',
            query: '(min-width: 992px)',
            onEnter: this.onEnter('desktop'),
            onLeave: this.onLeave('desktop'),
            onResize: this.onResize('desktop'),
            onFirstRun: this.onFirstRun('desktop')
        });
    };

    StateManager.prototype.addOnEnter = function (stateId, callback) {
        if(
            typeof this.callbacks[stateId] !== 'undefined'
            && typeof this.callbacks[stateId].enter !== 'undefined'
            && typeof callback === 'function'
        ) {
            this.callbacks[stateId].enter.push(callback);
        }
    };
    StateManager.prototype.addOnLeave = function (stateId, callback) {
        if(
            typeof this.callbacks[stateId] !== 'undefined'
            && typeof this.callbacks[stateId].leave !== 'undefined'
            && typeof callback === 'function'
        ) {
            this.callbacks[stateId].leave.push(callback);
        }
    };
    StateManager.prototype.addOnResize = function (stateId, callback) {
        if(
            typeof this.callbacks[stateId] !== 'undefined'
            && typeof this.callbacks[stateId].resize !== 'undefined'
            && typeof callback === 'function'
        ) {
            this.callbacks[stateId].resize.push(callback);
        }
    };
    StateManager.prototype.addOnFirstRun = function (stateId, callback) {
        if(
            typeof this.callbacks[stateId] !== 'undefined'
            && typeof this.callbacks[stateId].firstRun !== 'undefined'
            && typeof callback === 'function'
        ) {
            this.callbacks[stateId].firstRun.push(callback);
        }
    };

    StateManager.prototype.onEnter = function (stateId) {
        var self = this;
        return function() {
            for(var i = 0; i < self.callbacks[stateId].enter.length; i++) {
                self.callbacks[stateId].enter[i].apply();
            }
        };
    };
    StateManager.prototype.onLeave = function (stateId) {
        var self = this;
        return function() {
            for(var i = 0; i < self.callbacks[stateId].leave.length; i++) {
                self.callbacks[stateId].leave[i].call();
            }
        };
    };
    StateManager.prototype.onResize = function (stateId) {
        var self = this;
        return function() {
            for(var i = 0; i < self.callbacks[stateId].resize.length; i++) {
                self.callbacks[stateId].resize[i].call();
            }
        };
    };
    StateManager.prototype.onFirstRun = function (stateId) {
        var self = this;
        return function() {
            for(var i = 0; i < self.callbacks[stateId].firstRun.length; i++) {
                self.callbacks[stateId].firstRun[i].call();
            }
        };
    };

    window.SVHA = window.SVHA || {};
    window.SVHA.Utility = window.SVHA.Utility || {};
    window.SVHA.Utility.StateManager = new StateManager();
})(ssm, window);

